import React, {useState, useEffect} from 'react'
import {EditorState, ContentState, convertFromHTML, convertToRaw} from 'draft-js'

import {Editor} from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const HTMLField = props => {
  const [editorState, setEditorState] = useState(EditorState.createWithContent(
    ContentState.createFromBlockArray(
      convertFromHTML(props.val)
    )
  ),);

  const onChange = (state) => {
    setEditorState(state)
  }

  useEffect(() => {
    let html = draftToHtml(convertToRaw(editorState.getCurrentContent()))
    console.log('output: ', html);
    props.onChange(html);
  }, [editorState])

  useEffect(() => {
    // setEditorState(
    //     convertFromRaw(htmlToDraft(props.val))
    // )
  }, [props.val])

  return (
    <div className="HTMLField">
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={onChange}
      />
    </div>
  )
}

export default HTMLField